import React, { useState, useEffect, useRef } from "react";
import Button from "../Button";
import styles from "./ComparisonModal.module.css";
import PropTypes from "prop-types";
import { AddressCard } from "components/AddressCard/AddressCard";
import { Modal } from "components/Modal/Modal";
import Loader from "components/Loader";
import { useTranslation } from "react-i18next";

export function ComparisonModal({
  suggestedAddress,
  address,
  handleUseSuggested,
  handleUseOriginal,
  handleEditClick,
  onClose,
  isOpen,
  title,
  loading,
  isAdd,
}) {
  const [suggestedData, setSuggestedData] = useState({});
  const [addressData, setAddressData] = useState({});
  const {t} = useTranslation();

  useEffect(() => {
    if (isOpen) {
      if (address) {
        setAddressData({
          country: address.country,
          recipient: address.recipient,
          line1: address.line1,
          line2: address.line2,
          city: address.city,
          state: address.state,
          postalCode: address.postalCode,
          isVerified: address.isVerified,
        });
      } else {
        setAddressData({
          recipient: "",
          country: "",
          line1: "",
          line2: "",
          city: "",
          state: "",
          postalCode: "",
          isVerified: 0,
        });
      }
    }
  }, [address, isOpen, isAdd]);

  useEffect(() => {
    if (suggestedAddress) {
      setSuggestedData({
        line1: suggestedAddress.line1,
        line2: suggestedAddress.line2,
        city: suggestedAddress.city,
        state: suggestedAddress.state,
        country: suggestedAddress.country,
        postalCode: suggestedAddress.postalCode,
        latitude: suggestedAddress.latitude,
        longitude: suggestedAddress.longitude,
        isVerified: 1,

        suggestions: suggestedAddress.suggestions,
      });
    }
  }, [suggestedAddress]);

  const resetForm = () => {
    setAddressData({
      recipient: "",
      country: "",
      line1: "",
      line2: "",
      city: "",
      state: "",
      postalCode: "",
      isVerified: 0,
    });
    setSuggestedData({});
  };

  const handleCancel = () => {
    resetForm();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      classNames={styles.modal}
      title={title}
      children={
        <>
          <div className={styles.container}>
            {loading ? (
              <div className={styles.loader}>
                <Loader color={"#415364"} size={85} />
              </div>
            ) : (
              <>
                <div>
                  <h1 className={styles.title}>
                    {isAdd ? t("Please Confirm Your Address") : t("Update Address")}
                  </h1>
                </div>

                <div className={styles.suggestedAddressContainer}>
                  <AddressCard
                    original={false}
                    address={suggestedData}
                    title={t("Suggested Address")}
                    onClickUse={handleUseSuggested}
                  />
                </div>
                <div className={styles.userEnteredAddressContainer}>
                  <AddressCard
                    original={true}
                    address={addressData}
                    title={t("Original Address")}
                    onClickUse={handleUseOriginal}
                    onClickEdit={handleEditClick}
                  />
                </div>
                <div className={styles.cancel}>
                  <Button
                    className={styles.modalCancel}
                    buttonText={t("Cancel")}
                    onClick={handleCancel}
                  />
                </div>
              </>
            )}
          </div>
        </>
      }
    />
  );
}

ComparisonModal.propTypes = {
  suggestedAddress: PropTypes.object.isRequired,
  address: PropTypes.object.isRequired,
  handleUseSuggested: PropTypes.func.isRequired,
  handleUseOriginal: PropTypes.func.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
